/*
 DisplayResultManager Module

 */

import SkippairSpinner from './utils/skippairSpinner.js'

import CruiseCardsManager from './cruiseCardsManager.js'
import MapMarkerManager from './mapMarkerManager.js'
import InfoManager from './infoManager.js'
import PaginationManager from './paginationManager.js'
import CallMeManager from './callMeManager.js'


const DisplayResultManager = (function (CruiseCardsManager, MapMarkerManager, InfoManager, PaginationManager, SkippairSpinner) {
    // ================== VARIABLE ================== //
    var _currSharingType;
    var _spinner;
    var _callbacks = [];

    // ================== CONSTRUCTOR ================== //
    function DisplayResultManager() {
        // Singleton
        if (DisplayResultManager.instance) {
            throw new Error('DisplayResultManager is a singleton. Use DisplayResultManager.instance.');
        }
        // enforces new
        if (!(this instanceof DisplayResultManager)) {
            return new DisplayResultManager();
        }

        PaginationManager.onPageChange(_renderBaseResult, this);
        _spinner  = new SkippairSpinner($('#spinner'));
    };

    // ================== PUBLIC METHOD ================== //
    DisplayResultManager.prototype.renderFirstResult = function(base_result, info_data) {
        CallMeManager.reset()
        _currSharingType = info_data.sharing_type;
        _renderFirstResult(PaginationManager.paginateResult(base_result, 1), base_result);
    };

    DisplayResultManager.prototype.renderSearch = function(base_result, info_data, other_result) {
        $('#result-display').show();
        CallMeManager.reset()
        _spinner.hide();
        InfoManager.renderInfos(info_data);

        _currSharingType = info_data.sharing_type;
        _renderAllResult(PaginationManager.paginateResult(base_result, info_data.page), base_result, other_result);
        $('html').animate({scrollTop:0}, 500);
    };

    DisplayResultManager.prototype.renderLoader = function() {
        $('#result-display').hide();
        _spinner.show();
    };

    DisplayResultManager.prototype.onPageChange = function(callback, target) {
        _callbacks.push({
            'callback': callback,
            'target': target
        });
    };

    // ================== PRIVATE METHOD ================== //
    function _renderFirstResult (paginate_base_result, base_result) {
        CruiseCardsManager.displayFirstResult(paginate_base_result, _currSharingType);
        //MapMarkerManager.renderMarkers(base_result, _currSharingType);
    }

    function _renderAllResult (paginate_base_result, base_result, other_result) {
        CruiseCardsManager.displayAllResult(paginate_base_result, other_result, _currSharingType);
        //MapMarkerManager.renderMarkers(base_result, _currSharingType);
    }

    function _renderBaseResult (paginate_base_result) {
        _pageChange();
        CruiseCardsManager.displayBaseResult(paginate_base_result, _currSharingType);
    }

    function _pageChange() {
        for (var i = 0; i < _callbacks.length; i++) {
            _callbacks[i].callback.apply(_callbacks[i].target);
        }
    }

    DisplayResultManager.instance = new DisplayResultManager();

    return DisplayResultManager.instance;
})(CruiseCardsManager, MapMarkerManager, InfoManager, PaginationManager, SkippairSpinner);

export default DisplayResultManager


// WEBPACK FOOTER //
// ./search/static/search/js/displayResultManager.js